import {createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles';

const primaryText = '#f05a28';
const secondaryText = '#686778';
const primary = '#fff';

// Create a theme instance.
const theme = createMuiTheme({
    palette: {
        primary: {
            main: primary
        },
        secondary: {
            main: '#686778',
        },
        error: {
            main: '#9b0d0d',
        },
        background: {
            default: '#C8C8C8',
        },
        text: {
            primary: primaryText,
            secondary: secondaryText,
        },
    },

    typography: {
        fontSize: 16,
        fontFamily: "Raleway, sans-serif",
        h1: {
            fontSize: '2.8rem',
            fontFamily: "Poppins, sans-serif",
            lineHeight: 1.1
        },
        h2: {
            fontSize: '2rem',
            fontFamily: "Poppins, sans-serif",
            lineHeight: 1.1
        },
        h3: {
            fontSize: '1.7rem',
            fontFamily: "Poppins, sans-serif",
            lineHeight: 1.1
        },
    },
    overrides: {

        MuiInputAdornment: {
            root: {
                color: primaryText
            }
        },
        MuiInput: {
            input: {
                color: secondaryText
            },
            underline: {
                "&::after": {
                    borderBottom: '2px solid #f05a28'
                },
                "&:hover::after": {
                    borderBottom: '2px solid #f05a28'
                }
            },
        },
        MuiCircularProgress: {
            colorPrimary: {
                color: primaryText
            }
        },
        MuiFormLabel: {
            root: {
                "&$focused": {
                    color: primaryText
                }
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: '3rem'
            }
        },
        MuiListItem: {
            gutters: {
                paddingLeft: 12,
                paddingRight: 12,
            }
        },
        MuiButton: {
            contained: {
                "&:hover": {
                    color: primary,
                    backgroundColor: primaryText,
                    textDecoration: 'underline'
                },
                marginTop: '1rem',
                color: primary,
                backgroundColor: primaryText,
            }
        }
    }
});

export default responsiveFontSizes(theme);
